import { useState, useEffect } from "react";
import { apiGet, apiSend, errorMessage } from "./api";
import "./CreateUserModal.css";

function EditCardModal({ cardToEdit, onClose, onUpdated }) {
  const [orgs, setOrgs] = useState([]);
  const [form, setForm] = useState({
    name: cardToEdit.name,
    surname: cardToEdit.surname,
    email: cardToEdit.email,
    phone: cardToEdit.phone || "",
    points: cardToEdit.points,
    platform: cardToEdit.platform || "Android",
    status: cardToEdit.status,
    id_organization: cardToEdit.id_organization || "",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    apiGet("/api/organizations").then(setOrgs).catch(() => setOrgs([]));
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await apiSend(`/api/cards/${cardToEdit.id}`, "PUT", {
        ...form,
        // Champ vidé → NaN → 422 : on retombe sur 0
        points: parseInt(form.points) || 0,
        id_organization: form.id_organization ? parseInt(form.id_organization) : null,
      }, "Erreur lors de la modification");
      onUpdated();
      return;
    } catch (e) {
      setError(errorMessage(e, "Erreur lors de la modification"));
    }
    setLoading(false);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Modifier la carte</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>
        <p style={{ color: "#999", fontSize: 13, marginBottom: 16 }}>ID : {cardToEdit.id}</p>
        <form onSubmit={handleSubmit}>
          {error && <div className="modal-error">{error}</div>}
          <label>Nom</label>
          <input name="name" value={form.name} onChange={handleChange} required />
          <label>Prénom</label>
          <input name="surname" value={form.surname} onChange={handleChange} required />
          <label>Email</label>
          <input name="email" type="email" value={form.email} onChange={handleChange} required />
          <label>Téléphone</label>
          <input name="phone" value={form.phone} onChange={handleChange} />
          <label>Organisation</label>
          <select name="id_organization" value={form.id_organization} onChange={handleChange}>
            <option value="">Aucune</option>
            {orgs.map((o) => (
              <option key={o.id} value={o.id}>{o.name}</option>
            ))}
          </select>
          <label>Points</label>
          <input name="points" type="number" value={form.points} onChange={handleChange} min="0" />
          <label>Plateforme</label>
          <select name="platform" value={form.platform} onChange={handleChange}>
            <option value="Android">Android</option>
            <option value="Apple">Apple</option>
            {/* Valeurs héritées (Web/Mobile…) : gardées pour ne pas les écraser
                silencieusement à l'ouverture du formulaire */}
            {!["Android", "Apple"].includes(form.platform) && (
              <option value={form.platform}>{form.platform}</option>
            )}
          </select>
          <label>Statut</label>
          <select name="status" value={form.status} onChange={handleChange}>
            <option value="active">Active</option>
            <option value="disabled">Disabled</option>
            <option value="banned">Banned</option>
          </select>
          <button type="submit" className="modal-submit" disabled={loading}>
            {loading ? "Modification..." : "Enregistrer"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default EditCardModal;
